import { render, staticRenderFns } from "./UploadWord.vue?vue&type=template&id=8154f112"
import script from "./UploadWord.vue?vue&type=script&lang=js"
export * from "./UploadWord.vue?vue&type=script&lang=js"
import style0 from "./UploadWord.vue?vue&type=style&index=0&id=8154f112&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports